export const isPendingAction = (reducer) => ({ type }) => {
  return type.startsWith(`${reducer}/`) && type.endsWith('/pending');
}

export const isRejectedAction = (reducer) => ({ type }) => {
  return type.startsWith(`${reducer}/`) && type.endsWith('/rejected');
}

export const isFulfilledAction = (reducer) => ({ type }) => {
  return type.startsWith(`${reducer}/`) && type.endsWith('/fulfilled');
}